var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbattingEcosystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.23077V3.23077H0V0ZM5.38461 0H8.61539V3.23077H5.38461V0ZM14 0H10.7692V3.23077H14V0ZM0 5.38461H3.23077V8.61539H0V5.38461ZM8.61539 5.38461H5.38461V8.61539H8.61539V5.38461ZM10.7692 5.38461H14V8.61539H10.7692V5.38461ZM3.23077 10.7692H0V14H3.23077V10.7692ZM5.38461 10.7692H8.61539V14H5.38461V10.7692ZM14 10.7692H10.7692V14H14V10.7692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbattingEcosystem);
export default __webpack_public_path__ + "static/media/coinbatting-ecosystem.cc7bfce48f9a5b05ca3b79b87d4bb2d3.svg";
export { ForwardRef as ReactComponent };